import { PayPeriodEnum } from '@umss/shared/utils';

export interface FacilityPayPeriodSettings {
  id: number;
  facilityId: string;
  payPeriodType: PayPeriodEnum;
  payPeriodTypeDisplay: string;
  startDate: string;
  endDate: string;
  nextPayDate: string;
  firstPaymentDay: number;
  secondPaymentDay: number;
  isPendingUpdate: boolean;
}

export interface FacilityPayPeriodSetttingsUpdate {
  payPeriodType: PayPeriodEnum;
  firstPaymentDay: number;
  secondPaymentDay: number;
  anchorDate?: string;
}

export interface FacilityAttendanceSettingsUpdate {
  authorizedClockInRequired: boolean;
  requireContractorSignatureAtClockIn: boolean;
  managerMissedClockNotifications: boolean;
  contractorMissedClockNotifications: boolean;
}

export interface FacilityAttendanceSettings {
  id: number;
  facilityId: string;
  clockInWindowBeforeShiftMinutes: number;
  mobileClockInEnabled: boolean;
  computerClockInEnabled: boolean;
  authorizedClockInRequired: boolean;
  requireContractorSignatureAtClockIn: boolean;
  notifyManagersAfterMinutes: number;
  notifyContractorsAfterMinutes: number;
  managerMissedClockNotifications: boolean;
  contractorMissedClockNotifications: boolean;
}
